const ar = {
  AuthTitle: {
    Greetings: "مرحبًا بك في",
  },
  Auth: {
    EnterEmail: "أدخل البريد الإلكتروني",
    EnterPassword: "أدخل كلمة المرور",
    AgreeWith: "أوافق على",
    ProcessingPersonalData: "معالجة البيانات الشخصية",
    UserAgreement: "اتفاقية المستخدم",
    EmailRequiredError: "البريد الإلكتروني مطلوب",
    EmailWrongFormatError: "صيغة البريد الإلكتروني خاطئة!",
    PasswordRequiredError: "كلمة المرور مطلوبة",
    ForgotPassword: "نسيت كلمة المرور",
  },
  Login: {
    Title: "تسجيل الدخول",
    Subtitle: "أكمل الحقول أدناه لتسجيل الدخول إلى حسابك.",
    Login: "تسجيل الدخول",
    Register: "التسجيل",
    LoginError: "تم إدخال تسجيل دخول أو كلمة مرور غير صحيحة",
    BuyTeacherLessons: "شراء دروس مع معلم",
  },
  Register: {
    Title: "التسجيل",
    Subtitle: "أكمل الحقول أدناه لتسجيل حسابك.",
    Register: "التسجيل",
    Login: "تسجيل الدخول",
    EnterLastName: "أدخل الاسم الأخير",
    EnterFirstName: "أدخل الاسم",
    EnterEmail: "أدخل البريد الإلكتروني",
    EnterGender: "الجنس",
    EnterBirthday: "تاريخ الميلاد",
    EnterProfileCountryId: "الجنسية",
    EnterProfileCityId: "مدينة الإقامة",
    EnterProfileDegreeId: "المؤهل الدراسي",
    EnterPassword: "أدخل كلمة المرور",
    RepeatPassword: "أعد إدخال كلمة المرور",
    LastNameRequiredError: "الاسم الأخير مطلوب",
    LastNameMinLengthError: "الحد الأدنى للحروف هو 2",
    FirstNameRequiredError: "الاسم مطلوب",
    FirstNameMinLengthError: "الحد الأدنى للحروف هو 2",
    PhoneRequiredError: "رقم الهاتف مطلوب",
    PhoneInvalidError: "صيغة الهاتف غير صحيحة",
    GenderRequiredError: "الجنس مطلوب",
    BirthdayRequiredError: "تاريخ الميلاد مطلوب",
    ProfileCountryIdRequiredError: "الجنسية مطلوبة",
    ProfileCityIdRequiredError: "مدينة الإقامة مطلوبة",
    ProfileDegreeIdRequiredError: "المؤهل الدراسي مطلوب",
    PasswordMismatchError: "كلمات المرور غير متطابقة",
    PasswordMinLengthError: "الحد الأدنى للحروف هو 6",
  },
  Reset: {
    Title: "إعادة تعيين كلمة المرور",
    Subtitle:
      'أدخل البريد الإلكتروني الذي قدمته أثناء التسجيل وانقر على زر "استعادة".',
    Reset: "يعيد",
    Login: "مدخل",
    Success:
      "في غضون دقائق قليلة، ستتلقى بريدًا إلكترونيًا إلى <0>{{email}}</0> يحتوي على تعليمات حول كيفية استعادة كلمة المرور الخاصة بك.",
  },
  CookieNotice: {
    Message:
      "نحن نستخدم ملفات تعريف الارتباط لتحسين الموقع وتجربة المستخدم. من خلال الاستمرار في استخدام الموقع، فإنك توافق على استخدام ملفات تعريف الارتباط. يمكنك دائمًا تعطيل ملفات تعريف الارتباط في إعدادات المتصفح.",
    Agree: "قبول، لا تعرض مجددًا",
  },
  MainPage: {
    Title: "الرئيسية",
    TitleGreetings: "مرحبًا بك في",
    TitleGreetingsMiddle: "GOVORI",
    TitleGreetingsEnd: "RU!",
    MyCourses: "دوراتي",
    CourseContinue: "متابعة",
    CourseCountStart: "المتاح",
    CourseCount_one: "{{count}} دورة",
    CourseCount_other: "{{count}} دورات",
    AllCourses: "جميع الدورات",
    MyLessons: "دروسي",
    AllLessons: "جميع الدروس",
    EmptyCourses: "لا توجد دورات",
    EmptyLessons: "لا توجد دروس",
    BuyTeacherLessons: "شراء دروس مع معلم",
    BuyTeacherLessonsLink: "هنا",
    ForeignCardTooltip: "للبطاقات الصادرة خارج الاتحاد الروسي",
    NoActiveLicense: "ليس لديك ترخيص نشط.",
    GoIntoLesson: "انتقل إلى الدرس",
    FinishedLessons: "المنتهية",
    CanceledLessons: "المُلغاة",
  },
  CoursesPage: {
    Title: "دوراتي",
    TitleGreetings: "مرحبًا بك في",
    MyCourses: "دوراتي",
    CourseContinue: "متابعة",
    EmptyCourses: "لا توجد دورات",
    SearchPlaceholder: "البحث بالاسم",
    LevelPlaceholder: "المستوى",
    AllLevels: "جميع المستويات",
  },
  Menu: {
    Main: "الصفحة الرئيسية",
    Words: "الكلمات",
    Courses: "دوراتي",
    Lessons: "دروس مع المعلم",
    TeacherCorner: "ركن المعلم",
    AdditionalCourses: "دورات إضافية",
    UsefulLinks: "روابط مفيدة",
    Notifications: "الإشعارات",
    Video: "فيديو",
    TeacherGroups: "المجموعات",
    TeacherAttendance: "الحضور",
    TeacherClasses: "الفصول",
    TeacherReports: "التقارير",
    CreativeTasks: "المهام الإبداعية",
    Attendance: "الحضور",
  },
  Footer: {
    Copyright: "جميع الحقوق محفوظة",
    About: "عن الشركة",
    PrivacyPolicy: "سياسة استخدام البيانات",
    PrivacyProtect: "لائحة معالجة وحماية البيانات الشخصية",
  },
  Module: {
    exercise_one: "تمرين",
    exercise_few: "تمارين",
    Completed: "مكتمل",
    Result: "النتيجة",
    InWork: "قيد التقدم",
    Done: "منتهي",
  },
  SteppedProgress: {
    Completed: "مكتمل",
  },
  CourseDetails: {
    Title: "معلومات الدورة",
    Progress: "التقدم",
    Completed: "منتهي",
    Result: "النتيجة",
    Hours: "ساعات",
    Lessons: "دروس",
    Units: "وحدات",
    Unit: "وحدة",
    Exercises_zero: "{{count}} تمارين",
    Exercises_one: "{{count}} تمرين",
    Exercises_other: "{{count}} تمارين",
    Exercises_many: "{{count}} تمارين",
  },
  CourseUnitDetails: {
    Vocabulary: "الكلمات",
    Video: "فيديو",
    Grammar: "النحو",
    Reading: "القراءة",
    Writting: "الكتابة",
    Speaking: "المحادثة",
    Test: "الاختبار",
    Unknown: "غير معروف",
    EmptyExercises: "لا توجد تمارين",
  },
  EntranceTest: {
    ModalTitle: "تحديد مستواك المعرفي",
    ModalBody:
      "قم بإجراء الاختبار لتحديد مستوى إتقانك للغة الروسية. يستغرق الاختبار حوالي 40 دقيقة.",
    Cancel: "إلغاء",
    Take: "ابدأ الاختبار",
  },
  TeacherPage: {
    Title: "المعلم الرئيسي",
    MyLessons: "دروسي",
    MyModules: "وحداتي",
  },
  DistributorPage: {
    Title: "الموزع الرئيسي",
  },
  CoordinatorPage: {
    Title: "المنسق الرئيسي",
  },
  Button: { Send: "إرسال", Download: "تحميل" },
  Distributor: {
    Report: "التقارير",
    DateFrom: "من التاريخ",
    DateTo: "إلى التاريخ",
    Status: "الحالة",
    StatusReady: "جاهز",
    StatusPlanned: "مخطط",
    Actions: "الإجراءات",
    FromRequiredError: "خطأ حدد تاريخ البدء",
    ToRequiredError: "حدد تاريخ الانتهاء خطأ",
  },
  LessonsTable: {
    GroupName: "المجموعات",
    Status: "الحالة",
    StartDateTime: "التاريخ والوقت",
    Duration: "ساعات",
    Credentials: "الندوة: تسجيل الدخول / كلمة المرور",
    CredentialsCopied: "تم النسخ!",
    SortAlpabetically: "ترتيب أبجدي أ-ي",
  },
  LessonStatuses: {
    completed: "مكتمل",
    planned: "مخطط",
    earlyCanceledByCustomer: "أُلغي من قِبل المستمعين",
    earlyCanceledBySchool: "أُلغي من قِبل المعلم",
    lateCanceledByCustomer: "أُلغي متأخرًا من قِبل المستمعين",
    lateCanceledBySchool: "أُلغي متأخرًا من قِبل المعلم",
  },
  LessonAttendance: {
    Status: "اختر الحالة",
    Date: "اختر التاريخ",
    Time: "اختر الوقت",
    Duration: "المدة",
    AH: "ساعات",
    Students: "الطلاب",
    CheckAll: "اختر الكل",
    Comment: "التعليقات",
    Submit: "إرسال",

    restrictiveBackDateError: "التاريخ لا يمكن أن يكون أقل من المسموح خطأ",
    restrictiveForwardDateError: "التاريخ لا يمكن أن يكون أكثر من المسموح خطأ ",
    commentSizeError: "يجب أن تكون التعليق أقل من خطأ {{count}} كلمات",
    requiredFieldError: " هذا الحقل مطلوب خطأ ",
    requiredDateError: "أدخل التاريخ والوقت خطأ ",
    ExcessHoursWarning: "تم تجاوز عدد الساعات  ",
    MarkStudents: "حدد الطلاب الذين حضروا الفصل واحفظ التغييرات.",

    apiError: "لم يتم حفظ بياناتك. يرجى الاتصال بالدعم الفني online@dschool.ru",
    early_cancel_by_customer_not_acceptable:
      "الإلغاء المبكر من قبل المستخدم غير متاح، تم إلغاء حصتين بالفعل، يرجى الاتصال بالمنسق",
    early_cancel_by_school_not_acceptable:
      "الإلغاء المبكر من قبل المدرسة غير متاح، تم إلغاء حصتين بالفعل، يرجى الاتصال بالمنسق",
  },
  TeacherReportsPage: {
    Title: "التقارير",
    HeaderTitle: "التقارير",
    CreateReport: "إنشاء تقرير",
  },
  TeacherReportTable: {
    Title: "عنوان التقرير",
    CreationDate: "تاريخ الإنشاء",
    Period: "الفترة",
    Status: "الحالة",
    StatusDone: "منتهي",
    StatusPending: "قيد الانتظار",
    Actions: "الإجراءات",
    Statistics: "إحصائيات المنصة",
    CourseProgress: "تقدم الدورة",
    ActiveTime: "تقرير الوقت المستغرق على المنصة",
    EntranceTest: "اختبار الدخول",
    LecenseReport: "تقرير الرخص المستخدمة",
    HeaderTitle: "التقارير",
    CreateReport: "إنشاء تقرير",
    DeleteReport: "هل أنت متأكد؟",
    DeleteTooltip: "حذف",
    MailTooltip: "إرسال إلى البريد الإلكتروني",
    DownloadTooltip: "تحميل",
    DeleteGroupTooltip: "إزالة المحدد",
    MailGroupTooltip: "إرسال المحدد إلى البريد الإلكتروني",
    DownloadGroupTooltip: "تحميل المحدد",
  },
  CreateReportForm: {
    Statistics: "إحصائيات المنصة",
    CourseProgress: "تقدم الدورة",
    ActiveTime: "تقرير الوقت المستغرق على المنصة",
    Report: "تقريري",
    Title: "إنشاء تقرير",
    Type: "نوع التقرير",
    TypeLabel: "النوع",
    NameLabel: "العنوان",
    DateLabel: "التاريخ",
    DateFromLabel: "من",
    DateToLabel: "إلى",
    Name: "اسم التقرير",
    Period: "الفترة",
    PeriodFrom: "من",
    PeriodTo: "إلى",
    Date: "التاريخ",
    FilterListGroup: "المجموعة",
    FilterListStudent: "الطالب",
    FilterListCompany: "شركة العميل",
    FilterListTest: "اسم اختبار الدخول",
    FilterListSelectedStudents: "تم اختيار {{count}} طلاب من الفلتر",
    FilterListSelectedGroups: "تم اختيار {{count}} مجموعات من الفلتر",
    FilterListCompanies: "تم اختيار {{count}} شركات من الفلتر",
    FilterListSelectedTests: "تم اختيار {{count}} اختبارات دخول من الفلتر",
    FilterListSelectedPlaceholderStudents: "اختر الطلاب",
    FilterListSelectedPlaceholderGroups: "المجموعات المحددة",
    FilterListSelectedPlaceholderCompanies: "شركات العميل المحددة",
    FilterListSelectedPlaceholderTests: "اختر اختبارات الدخول",
    GroupsChosen: "المجموعات المحددة",
    ChooseAll: "اختر الكل",
    RemoveAll: "إزالة الكل",
    GroupName: "المجموعة",
    GroupDefault: "مجموعة افتراضية",
    Cancel: "إلغاء",
    Create: "إنشاء",
    TitleRequiredError: "العنوان مطلوب",
    FromRequiredError: "تاريخ بدء الفترة مطلوب",
    ToRequiredError: "تاريخ نهاية الفترة مطلوب",
    GroupsRequiredError: "اختر مجموعة أو أكثر!",
    OrderCreateError: "فشل في إنشاء تقرير جديد",
    FieldRequiredError: "هذا الحقل مطلوب",
    NoItems: "لا توجد مجموعات",
  },
  Gender: {
    Male: "ذكر",
    Female: "أنثى",
  },
  Role: {
    student: "طالب",
    teacher: "معلم",
    distributor: "موزع",
    coordinator: "منسق",
  },
  EmailNotConfirmed: {
    Title:
      "للدخول إلى المنصة، تم إرسال رسالة بريد إلكتروني إلى عنوان بريدك الإلكتروني، {{email}}. يرجى تأكيد عنوانك. إذا كانت لديك أي أسئلة، اكتب إلى online@dschool.ru",
    Back: "<< رجوع",
  },
  MyWordsPage: {
    Title: "كلماتي",
    EmptyWordList: "لا توجد كلمات للتعلم. اختر وحدة أخرى في الفلاتر",
  },
  WordsFilter: {
    Title: "العنوان",
    Clear: "مسح",
    EmptyCourses: "دورات فارغة",
    ChooseCourse: "اختر دورة",
    ChooseUnit: "اختر وحدة",
    EmptyUnits: "وحدات فارغة",
  },
  SetupPassword: {
    Title: "إعداد كلمة المرور",
    Subtitle:
      "تحتاج إلى تعيين كلمة مرور جديدة، أدخل كلمة المرور الجديدة وتأكيدها في الحقول أدناه",
  },
  SetupPasswordRedirect: {
    Title: "مطلوب اتخاذ إجراء",
    Description: "يجب تعيين كلمة مرور للمتابعة في استخدام هذه الخدمة.",
    Redirect: "تعيين كلمة المرور",
  },
  ChangePassword: {
    Password: "كلمة المرور",
    PasswordRepeat: "إعادة كلمة المرور",
    Confirm: "تأكيد",
    PasswordShortError: "يجب أن تكون كلمة المرور أطول من 6 أحرف",
    PasswordMismatch: "يجب أن تتطابق كلمات المرور",
    Success: "تم تغيير كلمة المرور بنجاح",
    Login: "الذهاب لصفحة تسجيل الدخول",
  },
  ProfilePage: {
    Title: "ملفي الشخصي",
  },
  Profile: {
    PersonalData: "المعلومات الشخصية",
    FirstName: "الاسم",
    LastName: "الاسم الأخير",
    BirthDate: "تاريخ الميلاد",
    Citizenship: "الجنسية",
    Degree: "التعليم",
    City: "مدينة الإقامة",
    NewPassword: "كلمة المرور الجديدة",
    ConfirmNewPassword: "تأكيد كلمة المرور الجديدة",
    Password: "كلمة المرور",
    Save: "حفظ",
    DataUpdateSuccess: "تم تحديث البيانات بنجاح",
    Settings: "الإعدادات",
    ShowPassingResults: "عرض نتيجة المرور",
  },
  UsefulLinks: {
    Title: "روابط مفيدة",
    GroupName: "اسم المجموعة:",
    Added: "أضيف",
    NoLinks: "لا توجد روابط",
  },
  DatePicker: {
    Today: "اليوم",
    Clear: "مسح",
  },
  Promocode: {
    Expired: "تم إيقاف التسجيل في المجموعة. يرجى التواصل مع مديرك",
  },
  TeachersAutocompleteFilter: {
    EnterTeacherName: "لم يتم العثور على معلمين",
    SelectTeacher: "اختر معلم",
  },
  Loading: {
    Error: "خطأ في التحميل، حاول تحديث الصفحة",
  },
  MultipleSelect: {
    SelectAll: "حدد الكل",
  },
  Attendance: {
    Title: "الحضور",
  },
};

export default ar;
